import {useState} from "react";
import Text from "./Text";
import { Col } from "./Flexbox";

const SelectableContainer = props => {
    const [hover, setHover] = useState(false);
    const {error, theme, style, active} = props;

    const isDark = theme.White !== "#FFFFFF";
    const getBorderColor = () => {
        if (error) return theme.Red;
        if (active || hover) return theme.Magenta;
        return isDark ? theme.THREEB : theme.Coco;
    }

    const bgColor = () => {
        return isDark ? theme.FOURFOUR : 'transparent';
    }

    return (
        <Col 
            onMouseEnter={() => {setHover(true); if (props.onHover) props.onHover(props.text);}} 
            onMouseLeave={() => {setHover(false); if (props.onHoverOut) props.onHoverOut();}}
            onClick={props.onClick}
            style={{
                flex:'none', 
                paddingRight: 16, 
                paddingLeft: 16, 
                paddingBottom: 4, 
                paddingTop: 4, 
                border: `1px solid ${getBorderColor()}`,
                boxShadow: active || hover ? `0 0 0 1px ${theme.Magenta}` : 'none',
                borderRadius: 4, 
                backgroundColor: bgColor(),
                cursor:'pointer',
                marginRight: 12,
                marginBottom: 12,
                ...style}}
                
            >
            <Text weight={"light"} size={17} color={active || hover ? (isDark ? theme.LMagenta : theme.Magenta) : (isDark ? theme.Black : theme.Audi)}>{props.text}</Text>
        </Col>
    )
}

export default SelectableContainer;